export const roadmapTabMeta = {
  id: "roadmap",
  label: "Roadmap học tập",
  shortLabel: "Plan",
};
